/**
 * Numbers of a text, language-independent: "2,179", "2 179" and "2179" are the
 * same number (a separator followed by exactly three digits is a thousands
 * separator); "2.04" and "2,04" are the same decimal.
 *
 * Shared by research verification (a claim's numbers must be in its evidence)
 * and editorial QA (a slide's numbers must be in the claims it cites).
 */
export function numbersOf(text: string): string[] {
  const joined = text.replace(/(\d)[\s  ,.](?=\d{3}(?!\d))/g, "$1");
  return [...new Set((joined.match(/\d+(?:[.,]\d+)?/g) ?? []).map((n) => n.replace(",", ".")))];
}
